import { Component, Input, signal } from '@angular/core';

@Component({
  selector: 'ecoupon-shared-ui-lip-ecoupon-header',
  imports: [],
  templateUrl: './lip-ecoupon-header.component.html',
  styleUrl: './lip-ecoupon-header.component.scss'
})
export class LipEcouponHeaderComponent {
  @Input() set imgHeader(item: string) {
    this.imgBanner.set(item);
  };
  imgBanner = signal<string>("");

}
